import { DialogV2, InputWrapper, Skeleton } from '@recruit-robin/robin-theme/web-components';
import { Phone } from '@recruit-robin/robin-theme/web-icons';
import { memo, useContext } from 'react';

import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { useStyles } from './CampaignPhoneReachOutDialog.styles';
import { usePosition } from './hooks/usePosition';

export const CampaignPhoneReachOutDialogSkeleton = memo(({ isVisible }: { isVisible: boolean }) => {
  const classes = useStyles();
  const { dictionary } = useContext(LocalizationContext);
  const { initialPosition, debouncedHandlePositionChange } = usePosition({ isVisible: true });

  return (
    <DialogV2.Root isVisible={isVisible} customCss={classes.root}>
      <DialogV2.Draggable initialPosition={initialPosition} onPositionChange={debouncedHandlePositionChange} />

      <DialogV2.Content customCss={classes.content}>
        <DialogV2.Header customCss={classes.contentHeader}>
          <div css={classes.contentHeaderTitle}>
            <Phone size={24} />
            <Skeleton variant="square" width={200} height={24} />
          </div>
          <Skeleton variant="square" width={137} height={36} />
        </DialogV2.Header>

        <DialogV2.Body customCss={classes.contentBody}>
          <Skeleton variant="square" width="100%" height={48} />

          <Skeleton variant="square" width="100%" height={120} />

          <InputWrapper label={dictionary.selectCallOutcome} requiredIndicator>
            <Skeleton variant="square" width="100%" height={48} />
            <Skeleton variant="square" width={200} height={36} />
          </InputWrapper>
        </DialogV2.Body>

        <DialogV2.Footer>
          <Skeleton variant="square" width={80} height={36} />
        </DialogV2.Footer>
      </DialogV2.Content>
    </DialogV2.Root>
  );
});
